import "./polyfills/cookieStore.polyfill";

import React, {useEffect} from "react";
import ReactDOM from "react-dom/client";
import {RouterProvider} from "react-router-dom";

import {router} from "./routes/router";
import {noConnectionRouter} from "./routes/noConnectionRouter";
import {AuthProvider} from "./components/Header/AuthContext";
import {NetworkProvider, useNetwork} from "./contexts/NetworkContext";

const Index = () => {
    const isOnline = useNetwork();

    useEffect(() => {
        if (isOnline) {
            import("./pages/NoConnectionPage/NoConnectionPage");
        }
    }, [isOnline]);

    return <RouterProvider router={isOnline ? router : noConnectionRouter}/>;
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <NetworkProvider>
            <AuthProvider>
                <Index/>
            </AuthProvider>
        </NetworkProvider>
    </React.StrictMode>
);
